module.exports = __webpack_public_path__ + "img/fb-w.3924c8f7.svg";